import { CompanyProfileSuggestion } from '@savgroup-front-common/types/CompanyDirectory';

import { ProposedActivityProfile } from '../OnboardingActivities.types';

import {
  ACTIVITY_TO_CUSTOMER_VERTICAL,
  CUSTOMERS_TO_ACTIVITY_TYPE,
  DOMAIN_TO_ACTIVITY_TYPE,
  VOLUME_TO_ACTIVITY_TYPE,
} from './adaptCompanyProfileToActivities.constants';

interface AdaptCompanyProfileToActivitiesArgs {
  suggestion?: CompanyProfileSuggestion;
}

export function adaptCompanyProfileToActivities({
  suggestion,
}: AdaptCompanyProfileToActivitiesArgs): ProposedActivityProfile {
  if (!suggestion) {
    return {
      customerVerticals: [],
      domains: [],
      volumes: [],
      customers: [],
    };
  }

  const customerVertical = ACTIVITY_TO_CUSTOMER_VERTICAL[suggestion.activity];
  const volume = VOLUME_TO_ACTIVITY_TYPE[suggestion.afterSalesVolume];
  const customers = CUSTOMERS_TO_ACTIVITY_TYPE[suggestion.customers];

  return {
    customerVerticals: customerVertical ? [customerVertical] : [],
    domains: (suggestion.domains ?? []).flatMap((domain) => {
      const activityType = DOMAIN_TO_ACTIVITY_TYPE[domain];

      return activityType ? [activityType] : [];
    }),
    volumes: volume ? [volume] : [],
    customers: customers ? [customers] : [],
    summary: suggestion.summary,
    confidence: suggestion.confidence,
  };
}
